import React from 'react';
import { PointType } from '../../../constants/PointType';
import { ReactComponent as PopularIcon } from '../../icons/popular.svg';
import { ReactComponent as RecentIcon } from '../../icons/recent.svg';
import { ReactComponent as HomeIcon } from '../../icons/home.svg';
import { ReactComponent as WorkIcon } from '../../icons/work.svg';
import { ReactComponent as SavedPlaceIcon } from '../../icons/savedPlace.svg';
import styles from './style.module.css';
import { StyledListItemIcon } from './StyledMenuItem';

const renderIconType = (type) => {
  switch (type) {
    case PointType.RECENT:
      return <StyledListItemIcon>
        <RecentIcon className={styles.icon} />
      </StyledListItemIcon>
    case PointType.POPULAR :
      return <StyledListItemIcon>
        <PopularIcon className={styles.icon} />
      </StyledListItemIcon>
    case PointType.HOME :
      return <StyledListItemIcon>
        <HomeIcon className={styles.icon} />
      </StyledListItemIcon>
    case PointType.WORK :
      return <StyledListItemIcon>
        <WorkIcon className={styles.icon} />
      </StyledListItemIcon>
    case PointType.SAVED_PLACE :
      return <StyledListItemIcon>
        <SavedPlaceIcon className={styles.icon} />
      </StyledListItemIcon>
    default: return null;

  }
}

export default renderIconType;
